<template>
    <div class="text-center bg-blue-50 border border-gray-200 py-10" v-if="show">
        <h3 class="text-md text-gray-500 font-semibold">{{ text }}</h3>
    </div>
</template>

<script>
export default {
    name: 'Alert',
    props: {
        text: String,
        show: Boolean
    }
}
</script>